var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" " + _vm._s(_vm.item.title) + " ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "4"
                  }
                },
                _vm._l(_vm.item.affected_servers, function(server, i) {
                  return _c(
                    "div",
                    {
                      key: i
                    },
                    [_vm._v(" " + _vm._s(server) + " ")]
                  )
                }),
                0
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-capitalize text-center",
                  attrs: {
                    cols: "12",
                    sm: "4"
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mb-1",
                      attrs: {
                        small: "",
                        color: _vm.statusColor(_vm.item.status)
                      }
                    },
                    [_vm._v(" mdi-circle ")]
                  ),
                  _vm._v(" " + _vm._s(_vm.item.status) + " ")
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "4"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        to: "/status/".concat(_vm.item.id)
                      }
                    },
                    [_vm._v("View Details")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }